module.exports = __webpack_public_path__ + "assets/img/33_834_big.3af62b20.jpg";